export default __webpack_public_path__ + "static/media/userdir.2833e63c.svg";